import { createBrowserHistory as createHistory } from 'history';
import { Provider } from 'mobx-react';
import React from "react";
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import Auth from './AuthCtx';
import stores from './stores';

const browserHistory = createHistory();

ReactDOM.render(
  <Provider {...stores}>
    <Auth>
      <Router history={browserHistory}>
          <App />
      </Router>
    </Auth>
  </Provider>,
  document.getElementById('root')
);
